import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';
import { getStorage } from 'firebase/storage';

// Firebase Configuration
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID
};

// Environment Validation
const envName = import.meta.env.VITE_ENV_NAME;
const projectId = firebaseConfig.projectId;

// Validate environment matches Firebase project
if (envName === 'PRODUCTION' && projectId !== 'propcloudai') {
  console.error(`Environment mismatch! VITE_ENV_NAME is "${envName}" but Firebase project is "${projectId}"`);
  throw new Error('Environment configuration error: Production build connected to wrong Firebase project.');
}

if (envName === 'DEVELOPMENT' && projectId !== 'propcloudai-dev') {
  console.error(`Environment mismatch! VITE_ENV_NAME is "${envName}" but Firebase project is "${projectId}"`);
  throw new Error('Environment configuration error: Development build connected to wrong Firebase project.');
}

// Log environment info in development
if (envName === 'DEVELOPMENT') {
  console.log(`[PropInvest Website] Running in DEVELOPMENT mode`);
  console.log(`[PropInvest Website] Firebase Project: ${projectId}`);
}

const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
export const functions = getFunctions(app);
export const storage = getStorage(app);

export default app;
